export * from "./catalog-filter-item";
export * from "./catalog-carousel-item";

import { CatalogCarouselItemComponent } from "./catalog-carousel-item";
import { CatalogFilterItemComponent } from "./catalog-filter-item";

export const CatalogLayoutAtoms = [
  CatalogFilterItemComponent,
  CatalogCarouselItemComponent,
];
